import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { authorSchema, identitySchema } from '@/core/components';

export const patentSchema = z.object({
  title: z.string().min(3),
  type: identitySchema,
  state: identitySchema,
  registrationNo: z
    .string()
    .refine((value): boolean => value.trim().length > 0, { params: { i18n: 'custom.required' } }),
  institutions: z.array(identitySchema).min(1),

  owner: identitySchema,
  submissionYear: z.number(),
  grantingYear: z.number().nullable(),
  authors: z.array(authorSchema).min(1),
  universityAffiliatedNoOfAuthors: z.number().nullable(),
});

export const defaultPatentValues: DefaultValues<PatentSchema> = {
  title: '',
  registrationNo: '',
  institutions: [],
  grantingYear: null,
  universityAffiliatedNoOfAuthors: null,
};

export type PatentSchema = z.infer<typeof patentSchema>;
